import React, { forwardRef } from 'react';
import {
  Col,
  Row, Skeleton, Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { textColor } from '@helpers/color';
import BasicButtonTxt from '@components/atoms/basic-button-txt';
import { PDFExportProps } from './types';

const PDFExport = forwardRef<HTMLDivElement, PDFExportProps>(({
  exportPDF,
  loading,
  children,
}, ref) => {
  const { t } = useTranslation();
  const { Text } = Typography;

  return (
    <Skeleton loading={loading}>
      <Row gutter={[50, 50]}>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className="flex flex-row justify-end gap-3"
        >
          <BasicButtonTxt
            content={(
              <Text
                className={`${textColor.white}
                py-0.5 text-sm xs:text-xs sm:text-xs md:text-xs lg:text-xs xl:text-xs 2xl:text-xs font-bold`}
              >
                {t('job.downloadPDF')}
              </Text>
            )}
            type="primary"
            onClick={exportPDF}
            size="large"
          />
        </Col>

        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className="flex flex-row justify-end gap-3"
        >
          <div ref={ref}>
            {children}
          </div>
        </Col>
      </Row>
    </Skeleton>
  );
});

PDFExport.displayName = 'PDFExport';

export default PDFExport;
